import {
  CreditorDetailResource,
  CreditorType,
} from "@gocardless/api/dashboard/types";
import { t, Trans } from "@lingui/macro";
import { FontWeight, Text } from "@gocardless/flux-react";
import { i18n } from "@lingui/core";

import { getBankAccountHolderDetails } from "src/components/routes/Setup/verification-status/helpers/getBankAccountHolderDetails";

interface ExperimentsEnabled {
  copEnabled: boolean;
  pennyTestImprovementsEnabled: boolean;
}

interface useAddBankFormDescriptionProps {
  experimentsEnabled: ExperimentsEnabled;
  creditorType: CreditorType | undefined;
  companyAccountHolderName: string | undefined;
  creditorDetails: CreditorDetailResource | undefined;
}

export const useAddBankFormDescription = ({
  experimentsEnabled: { copEnabled, pennyTestImprovementsEnabled },
  creditorType,
  companyAccountHolderName,
  creditorDetails,
}: useAddBankFormDescriptionProps) => {
  if (!creditorType || !creditorDetails?.detail) {
    return;
  }
  const { isIndividual, tradingName, personName } = getBankAccountHolderDetails(
    creditorType,
    creditorDetails.detail
  );
  const creditorTypeNameMapping: { [key in CreditorType]: string } = {
    [CreditorType.Individual]: tradingName
      ? i18n._(t`name or trading name`)
      : i18n._(t`name`),
    [CreditorType.Company]: i18n._(t`business name`),
    [CreditorType.Charity]: i18n._(t`Charity name`),
    [CreditorType.Partnership]: i18n._(t`Partnership name`),
    [CreditorType.Trust]: i18n._(t`Trust name`),
  };

  const accountHolderName = isIndividual
    ? personName
    : companyAccountHolderName;

  const accountHolderNameComponent =
    accountHolderName && !tradingName ? (
      <Text weight={FontWeight.Bold}>{`(${accountHolderName}) `}</Text>
    ) : null;

  if (
    (copEnabled && creditorType === CreditorType.Company) ||
    pennyTestImprovementsEnabled
  ) {
    return (
      <Trans>
        The bank account must be in your {creditorTypeNameMapping[creditorType]}{" "}
        {accountHolderNameComponent}
      </Trans>
    );
  }
  return (
    <Trans>
      The bank account{" "}
      <Text weight={FontWeight.Bold}>must be in the name of and owned</Text> by
      the legal entity entered earlier in the setup.
    </Trans>
  );
};
